import { ofType } from "redux-observable";
import { ajax } from "rxjs/ajax";
import { map, switchMap, catchError } from "rxjs/operators";

import {
  FETCH_PHYSICAL_ORGANIZATIONS,
  FETCH_PHYSICAL_ORGANIZATIONS_SUCCESS,
  FETCH_PHYSICAL_ORGANIZATIONS_FAIL,
} from "../../constants";

const fetchPhysicalOrganizations = (action$, state$) =>
  action$.pipe(
    ofType(FETCH_PHYSICAL_ORGANIZATIONS),
    switchMap((action) => {
      // Build query parameters manually to ensure %20 encoding
      let queryParams = 'organizationType=physical';

      if (action.filters) {
        if (action.filters.country) {
          queryParams += `&country=${encodeURIComponent(action.filters.country)}`;
        }
        if (action.filters.subcategory) {
          queryParams += `&subcategory=${encodeURIComponent(action.filters.subcategory)}`;
        }
      }

      const fullUrl = `${state$.value.auth.server}/admin/organizations?${queryParams}`;
      console.log('Fetching Physical Organizations from:', fullUrl);
      console.log('Filters:', action.filters);

      return ajax({
        url: fullUrl,
        headers: {
          Authorization: `Bearer ${state$.value.auth.LIPToken}`,
        },
        responseType: "json",
        crossDomain: true,
        method: "GET",
      }).pipe(
        map((response) => {
          console.log('Physical Organizations API Response:', response);
          return {
            type: FETCH_PHYSICAL_ORGANIZATIONS_SUCCESS,
            data: response.response,
          };
        }),
        catchError((error) => {
          console.error('Physical Organizations API Error:', error);
          return [{
            type: FETCH_PHYSICAL_ORGANIZATIONS_FAIL,
            error: error
          }];
        })
      );
    }),
  );

export default fetchPhysicalOrganizations;

